<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex content-action align-items-center">
                <div class="input-group border-bottom position-relative" style="width: 190px">
                    <input
                        class="form-control bg-transparent border-none pr-4"
                        :placeholder="$t('common.search')"
                        aria-label="Search"
                        v-model="searchKeyword"
                        style="min-width: 190px"
                    />
                    <i
                        class="fa fa-search position-absolute"
                        style="top: 50%; right: 4px; margin-top: -6px"
                    />
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="listData"
                :fields="fields"
                show-empty
                :filter="searchKeyword"
                :filter-included-fields="['name']"
            >
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(pathEn)="data">
                    <b-button v-if="data.value" variant="link" @click="downloadFile(data.value)">
                        <i class="fa fa-download"></i>
                    </b-button>
                </template>
                <template v-slot:cell(pathVi)="data">
                    <b-button v-if="data.value" variant="link" @click="downloadFile(data.value)">
                        <i class="fa fa-download"></i>
                    </b-button>
                </template>
                <template v-slot:cell(pathDe)="data">
                    <b-button v-if="data.value" variant="link" @click="downloadFile(data.value)">
                        <i class="fa fa-download"></i>
                    </b-button>
                </template>
                <template v-slot:cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có dữ liệu</span>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { saveAs } from 'file-saver';
import API_CONFIG from '@/api-config';

export default {
    async mounted() {
        await this.$nextTick();
        this.listData = await this.getList();
    },
    data: function() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'nameEn',
                    label: 'Tên tiếng Anh'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'nameVi',
                    label: 'Tên tiếng Việt'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'author',
                    label: 'Tác giả'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'year',
                    label: 'Năm'
                },
                {
                    tdClass: 'align-middle text-center',
                    thClass: 'fixed-actions-col text-center',
                    key: 'pathEn',
                    label: 'EN',
                    thStyle: { width: '50px' }
                },
                {
                    tdClass: 'align-middle text-center',
                    thClass: 'fixed-actions-col text-center',
                    key: 'pathVi',
                    label: 'VN',
                    thStyle: { width: '50px' }
                },
                {
                    tdClass: 'align-middle text-center',
                    thClass: 'fixed-actions-col text-center',
                    key: 'pathDe',
                    label: 'DE',
                    thStyle: { width: '50px' }
                }
            ],
            searchKeyword: null,
            listData: []
        };
    },
    methods: {
        ...mapActions({
            getList: 'report/getList',
            download: 'file/download'
        }),
        async downloadFile(item) {
            const url = API_CONFIG.BASE_URL + 'download?fileName=' + item;
            saveAs(url, item.split('/').pop());
        }
    }
};
</script>
